import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'antd';
import PropTypes from 'prop-types';

import './index.less';
import './animate.css';

class NotMatch extends PureComponent {

  render() {
    return (
      <div className="aly-not-match">
        <div className="aly-general-card">
          <img src="https://img.alicdn.com/tfs/TB1NGSMirSYBuNjSspiXXXNzpXa-443-340.png" />
          <p>{this.props.text}</p>
          <Button className='bounceIn' onClick={() => this.props.history.push('/')}>返回首页</Button>
        </div>
      </div>
    )
  }
}

NotMatch.propTypes = {
  text: PropTypes.string,
};

export default withRouter(NotMatch);


// WEBPACK FOOTER //
// ./src/components/NotMatch/index.jsx